import { default as doArticlesModel } from './defaultModel';
import { default as doReleaseModel } from './releaseModel';

export const sagaArticlesModel = doArticlesModel.sagas;
export const sagaReleaseModel = doReleaseModel.sagas;
